import { ElementRef, Renderer2, Directive, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[appSrcDesktopLandscape169]'
})
export class SrcDesktopLandscape169Directive implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @Input() appSrcDesktopLandscape169: string;

  filepath = environment.allegati.filePath;

  ngOnInit() {
    if (!this.appSrcDesktopLandscape169) { return; }
    const estensione = this.appSrcDesktopLandscape169.split('.').pop();
    const src = this.filepath + this.appSrcDesktopLandscape169.replace('.' + estensione, '_landscape_16_9_desktop.' + estensione);
    this.renderer.setProperty(this.el.nativeElement, 'src', src);
  }
}

